import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Blocks route unless the user has one of the allowed roles.
 * Unauthenticated → /login. Wrong role → home.
 */
export function RoleGuard({ roles = [], children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#FDFBF7]" data-testid="role-loading">
        <div className="inline-block h-10 w-10 rounded-full border-4 border-[#4361EE] border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
